import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VForm,
    {
      ref: "form",
      staticClass: "ns-credit-card-form",
      attrs: { "lazy-validation": "" },
    },
    [
      _c("h2", [
        _c("span", { staticClass: "title-small-bold" }, [
          _vm._v(_vm._s(_vm.t.sepaFormTitle)),
        ]),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "secure" },
          [
            _c("NsIcon", { attrs: { "icon-name": "icon-lock" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.t.secure))]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "p-icon-large",
        attrs: {
          src: "https://www.nuskin.com/content/dam/apps/checkout/creditcards/v2/CC-54.png",
        },
      }),
      _vm._v(" "),
      _c("p", [
        _vm._v(_vm._s(_vm.t.accountHolderLabel) + ": " + _vm._s(_vm.name)),
      ]),
      _vm._v(" "),
      _c(VTextField, {
        staticClass: "flex-column",
        attrs: {
          required: "",
          label: _vm.t.ibanLabel,
          "validate-on-blur": "",
          autofocus: "",
          rules: _vm.rules,
        },
        on: { input: _vm.sepaChanged },
        model: {
          value: _vm.sepaNumber,
          callback: function ($$v) {
            _vm.sepaNumber = $$v
          },
          expression: "sepaNumber",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }